import type {
  ActualVsBudgetPeriod,
  PortfolioActualVsBudgetResponse,
} from '@/features/actual-vs-budget-production/types'

export interface ActualVsBudgetHttpClient {
  get(
    url: string,
    config?: { params?: Record<string, string> }
  ): Promise<{ data: PortfolioActualVsBudgetResponse }>
}

export async function getPortfolioActualVsBudget(
  period: ActualVsBudgetPeriod,
  client: ActualVsBudgetHttpClient
) {
  const response = await client.get('/companies/actual-vs-budget', {
    params: { period },
  })
  return response.data
}
